import { runtimeConfigValue } from './runtime-config';

export const environment = {
  appVersion: '0.0.2',
  production: true,
  sentryDsn: 'https://f1076f1c8ad03b70cd063d78a2d6a50e@o4511022011187200.ingest.de.sentry.io/4512102094340176',
  mixpanelToken: '7b92af584e0c45eae74e359854e2e916',
  mixpanelApiHost: 'https://api-eu.mixpanel.com',
  mixpanelRecordSessionsPercent: 100,
  /** Same key as legacy JretailBasic for encrypting SMTP credentials sent to `mail-server`. */
  cryptoKey: 'JR@a?(fLJ9av0yn]',
  paramName: '@PRM_',
  /** Must match legacy JretailBasic / backend path segment (not kebab-case). */
  generateCodeSelector: 'generatecode',
  entityLockSelector: 'lock',
  entityUnlockSelector: 'unlock',
  changesSelector: 'persist',
  keycloakUrl: runtimeConfigValue('keycloakUrl', 'https://auth.j-suite.com'),
  /** Same key as non-prod; production builds do not auto-fill the login form from this. */
  keycloakDevelopmentRealm: 'development',
  keycloakClientId: runtimeConfigValue('keycloakClientId', 'jretail.basic'),
  apiUrl: runtimeConfigValue('apiUrl', 'https://dev-api-gateway.j-suite.com/jretail-backend/'),
  authUrl: runtimeConfigValue('authUrl', 'https://dev-api-gateway.j-suite.com/auth-service/'),
  scheduleUrl: runtimeConfigValue('scheduleUrl', 'https://dev-api-gateway.j-suite.com/jretail-backend'),
  restaurantUrl: runtimeConfigValue(
    'restaurantUrl',
    'https://dev-api-gateway.j-suite.com/restaurant-automation-service'
  ),
  fuelUrl: runtimeConfigValue(
    'fuelUrl',
    'https://dev-api-gateway.j-suite.com/fuel-management-service/api/v1'
  ),
  grafanaUrl: runtimeConfigValue(
    'grafanaUrl',
    'http://dev-grafana.kalemyazilim.internal/d/d8bdda9f-a9b2-40b8-ac30-5db6f5f66bda/jretail-dashboard?orgId=1&kiosk'
  ),
  reportingAppUrl: runtimeConfigValue('reportingAppUrl', 'https://report.j-retail.com'),
  reportPayloadTtlMs: 60000,
  spreadsheetOpenUrl: runtimeConfigValue(
    'spreadsheetOpenUrl',
    'https://dev-api-gateway.j-suite.com/jretail-backend/spreadsheet/open'
  ),
  spreadsheetSaveUrl: runtimeConfigValue(
    'spreadsheetSaveUrl',
    'https://dev-api-gateway.j-suite.com/jretail-backend/spreadsheet/save'
  ),
  spreadsheetOpenPath: 'spreadsheet/open',
  spreadsheetSavePath: 'spreadsheet/save',
};
